export default __webpack_public_path__ + "static/media/dingding-o.2067a632.svg";